import farmsConfig from 'config/constants/farms'

let farmsPidToVersion: Map<number, number> = null

/**
 * there are v1 and v2 farms with same pid, this is mainly for farmBoost
 */
export const getFarmVersionFromPid = (pid: number): number => {
  if (!farmsPidToVersion) {
    farmsPidToVersion = new Map()
    farmsConfig.forEach((f) => {
      farmsPidToVersion.set(f.pid, f.version)
    })
  }

  return farmsPidToVersion.get(pid)
}
